module.exports = __webpack_public_path__ + "fe89826740aa1a88d7eab31d89c8fdef.png";